var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-list-item',{attrs:{"checkbox":"","readonly":"","disabled":"","checked":_vm.checked,"title":_vm.$t('events.' + _vm.index),"after":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }